<template>
	<inertia-head title="Video Library" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Video Library</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Video Library Management List</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content">
		<div class="block border-bottom">
			<div class="block-content">
				<form @submit.prevent="changeCategory">
					<div class="row">
						<div class="col-md-4 mb-4">
							<div class="input-group">
								<span class="input-group-text">Category</span>
								<select v-model="form.category" class="form-select">
									<option value="">All</option>
									<optgroup v-for="(category,index) in videoCategories" :label="index">
										<option
											v-for="(cat,c_index) in category"
											:key="c_index"
											:value="c_index"
										>
											{{ cat }}
										</option>
									</optgroup>
								</select>
							</div>
						</div>
						<div class="col-md-3 mb-4">
							<div class="input-group">
								<span class="input-group-text">Filter By</span>
								<select v-model="form.filterby" class="form-select">
									<option value="">ALL</option>
									<option value="1">Featured</option>
									<option value="0">Not Featured</option>
								</select>
							</div>
						</div>
						<div class="col-md-2 mb-4">
							<div class="form-group">
								<input v-model="form.search" type="text" id="search" name="search" class="form-control" placeholder="Search" />
							</div>
						</div>
						<div class="col space-x-1 mb-4">
							<button
								type="submit"
								class="btn btn-secondary"
								:disabled="!form.isDirty || form.processing"
							>
								<i class="fa fa-search me-1"></i>Display
							</button>
							<button
								@click="addVideo"
								type="button"
								class="btn btn-info"
							>
								<i class="fa fa-plus me-1"></i>Add
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<pagination :collections="videoLibraries" />
		<div v-for="(video,v_index) in videoLibraries.data" class="block mb-1" :class="{'border-start border-danger border-5':video.is_live==1}">
			<div class="block-content block-content-full">
				<div class="row">
					<div class="col-md-3">
						<img :src="video.video_img_url??'/media/videos/vimeo_image.jpeg'" style="width:100%"/>
					</div>
					<div class="col-md-9">
						<p class="m-0"><span class="fw-bold">{{video.title}}</span>
							<span v-if="video.is_featured==1" class="badge bg-success fs-xs fst-italic fw-normal ms-2">Featured</span>
							<span v-if="video.is_live==1" class="badge bg-danger fw-normal ms-2"><i class="fa fa-video fs-xs me-1"></i>LIVE</span>
						</p>
						<div class="fs-sm fw-normal text-muted mb-2">
							<span v-if="video.category.includes('_course')" class="me-3">
								<i class="fa fa-fw fa-tag opacity-50 me-1"></i>
								<span class="badge bg-flat"><span v-if="video.module>0">Module:</span> {{ getModuleTitle(video.module) }}</span>
							</span>
							<span class="me-3">
								<i class="fa fa-fw fa-calendar-alt opacity-50 me-1"></i>
								{{ video.start_display }}
							</span>

							<div class="form-check form-switch form-check-inline">
								<input
									class="form-check-input"
									type="checkbox"
									:value="video.is_active"
									:id="video.id"
									name="example-switch-inline1"
									:checked="video.is_active"
									@change="toggleStatus(video.id,video.is_active)"
								/>
								<label class="form-check-label fw-semibold" :for="video.id">
									{{ video.is_active ? 'ACTIVE' : 'IN-ACTIVE' }}
								</label>
							</div>
							<div><span class="badge bg-secondary">{{getCategoryTitle(video.category)}}</span></div>
						</div>	
					</div>
				</div>
			</div>
			<div class="block-content block-content-full block-content-sm bg-body-light fs-sm space-x-1">
				<button @click="updateVideo(v_index)" type="button" class="btn btn-outline-info btn-sm"><i class="fa fa-edit me-1"></i>Edit</button>
				<button @click="selectDeleteVideo(video.id)" type="button" class="btn btn-outline-danger btn-sm"><i class="fa fa-times me-1"></i>Delete</button>
			</div>
		</div>
		<div v-if="videoLibraries.data.length==0" class="block mb-1">
			<div class="block-content block-content-full">
				<h1 class="text-center text-danger">No Video Found</h1>
			</div>
		</div>
		<div class="mt-3">
			<pagination :collections="videoLibraries" />
		</div>
	</div>


	<modal ref="deleteModal" size="modal-md">
		<template #title>
			Delete Confirmation
		</template>
		<template #body>
			<div class="mb-4">
				<p class="h5">Are you sure, you want to delete this details?</p>
			</div>
		</template>
		<template #footer>
			<button @click="confirmDeleteVideo" type="button" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i> Delete</button>
			<button type="button" class="btn btn-sm btn-secondary" @click="deleteModal.toggleModal()"><i class="fa fa-times"></i> Cancel</button>
		</template>
	</modal>

	<AddUpdateVideoLibraryModal
		key="VideoModal"
		ref="addUpdateVideoLibraryModal"
		:category="category"
		:categories="videoCategories"
		:courseModules="courseModules"
		:live_exist="live_exist"
	/>

</template>

<script>
	import { onMounted, watch, ref, reactive } from 'vue';
	import { useForm } from '@inertiajs/inertia-vue3';
	import AuthLayout from '../../Layouts/AuthLayout';
	import { createToaster } from '@meforma/vue-toaster';
	import { Inertia } from '@inertiajs/inertia';
	import AddUpdateVideoLibraryModal from '../../Components/Admin/AddUpdateVideoLibraryModal'

	export default{
		layout: AuthLayout,
		props: {
			videoLibraries		: Object,
			videoCategories		: Object,
			category			: String,
			filterby			: String,
			search				: String,
			courseModules		: Object,
			api_response 		: Object,
			live_exist 			: Number
		},
		components:{AddUpdateVideoLibraryModal},
		setup(props){

			const deleteModal = ref(null);

			const selected_delete_id = ref(null);

			const toast = createToaster();

			const action = ref('add');

			const form = useForm({
							category 	: props.category,
							filterby 	: props.filterby,
							search 		: props.search,
							is_active 	: 0,
						})

			const addUpdateVideoLibraryModal = ref(null);

			const changeCategory = () => {
											Inertia.get(route('admin.video-library',
												{
													category 	: form.category,
													filterby 	: form.filterby,
													search 		: form.search
												})
											)
										}

			const getCategoryTitle = (category)=>{

										var title = Object.entries(props.videoCategories).filter((data,key)=>{
											if(data[1][category]!==undefined)
											{
												return data[1][category];
											}
										});
										return title[0][1][category];
									}

			const getModuleTitle = (_module)=>{
									var mod = "";
									
									mod = props.videoLibraries.data.filter(function(data){
										if(_module==data.id)
										{
											return data;
										}
									});

									return mod[0]?mod[0].title:'Main Module';
								}


			const toggleStatus = (_id,is_active)=>{
									action.value = "update";
									form.is_active = (is_active==1) ? 0 : 1;
									form.put('video-library/status/'+_id, {
										preserveState: true,
										preserveScroll: true,
										only:['videoLibraries,api_response'],
									})
								}

			const addVideo = ()=>{

								action.value = "add";
								addUpdateVideoLibraryModal.value.setVideoContent(action.value,null);
								addUpdateVideoLibraryModal.value.toggleModal();
							}

			const updateVideo = (_index)=>{

									action.value = "update";

									addUpdateVideoLibraryModal.value.setVideoContent(action.value,props.videoLibraries.data[_index]);

									addUpdateVideoLibraryModal.value.toggleModal();
								}

			const selectDeleteVideo = (_id)=>{
										selected_delete_id.value = _id;
										deleteModal.value.toggleModal();
									}

			const confirmDeleteVideo = ()=>{
										deleteVideo(selected_delete_id.value);
									}

			const deleteVideo = (_id) => {
									action.value = "delete";
									Inertia.delete('video-library/'+_id,
									{
										preserveState: true,
										preserveScroll: true,
										only:['videoLibraries','courseModules','api_response'],
										onSuccess:()=> {
											selected_delete_id.value = null;
											deleteModal.value.toggleModal();
										}
									})
								}

			watch(()=>props.api_response, (value) => {
			
				if(value!=null)
				{
					var action_msg = action.value=='add'?'added':(action.value=='update'?'updated':'deleted'); 

					if(value.result=="success")
					{
						toast.show("Successfully "+action_msg, { type: value.result});
					}else
					{
						toast.show("Failed to process", { type: "error"});
					}
				}
			})

			return{
				selected_delete_id,
				selectDeleteVideo,
				deleteModal,
				confirmDeleteVideo,
				toast,
				action,
				form,
				getModuleTitle,
				getCategoryTitle,
				toggleStatus,
				changeCategory,
				addUpdateVideoLibraryModal,
				addVideo,
				updateVideo,
				deleteVideo
			}

		}
	}

</script>